<script setup lang="ts">
import { useSubscribtionToggle } from "@/api/recipients-query";
import { mdiBellOffOutline, mdiBellRingOutline } from "@mdi/js";
import { ResourceIdentity } from "@soft-db/monitoring-api-client";
import { Button, ButtonProps, confirm, Icon, Tooltip } from "@soft-db/ui";

const props = withDefaults(
	defineProps<{
		resource: ResourceIdentity;
		tooltip?: string;
		text?: boolean;
		btnProps?: ButtonProps;
		btnActiveProps?: ButtonProps;
		btnInactiveProps?: ButtonProps;
		confirmation?: boolean;
	}>(),
	{
		btnProps: () => ({}),
		btnActiveProps: () => ({ variant: "default", color: "success" }),
		btnInactiveProps: () => ({ variant: "outline", color: "default" }),
	}
);

const { t } = useI18n();
const { isSubscribed, toggle } = useSubscribtionToggle(() => props.resource);

async function toggleSubscription() {
	const confirmText = isSubscribed.value
		? t("common.unsubscriptionConfirmation")
		: t("common.subscriptionConfirmation");
	if (!props.confirmation || (await confirm.yesNo(confirmText))) {
		toggle();
	}
}

const buttonProps = computed(() => {
	if (isSubscribed.value) {
		return {
			...props.btnProps,
			...props.btnActiveProps,
		};
	} else {
		return {
			...props.btnProps,
			...props.btnInactiveProps,
		};
	}
});

const buttonText = computed(() => {
	if (isSubscribed.value) return t("common.unsubscribe");
	else return t("common.subscribe");
});
</script>

<template>
	<Tooltip :tooltip="tooltip" :disabled="tooltip == null">
		<Button v-bind="buttonProps" @click="toggleSubscription">
			<Icon :d="isSubscribed ? mdiBellRingOutline : mdiBellOffOutline" />
			<span v-if="text">{{ buttonText }}</span>
		</Button>
	</Tooltip>
</template>
